const storeConfigs: Record<string, StoreConfig> = {
	alert: {
		name: 'alert',
	},
	auth: {
		name: 'auth',
		persist: [
			{
				storage: sessionStorage,
				pick: ['isRefreshing'],
			},
		],
	},
	backend: {
		name: 'backend',
	},
	cancelTokens: {
		name: 'cancelTokens',
	},
	client: {
		name: 'client',
	},
	collection: {
		name: 'collection',
	},
	collectionFilter: {
		name: 'collectionFilter',
		persistAll: true,
	},
	lia: {
		name: 'lia',
		persistAll: true,
	},
	locale: {
		name: 'locale',
		persist: [{ pick: ['locale'], storage: sessionStorage }],
	},
	nav: {
		name: 'nav',
	},
	reviewDocument: {
		name: 'reviewDocument',
		persist: [{ pick: ['onlyIncomplete'], storage: sessionStorage }],
	},
	tableState: {
		name: 'tableState',
	},
	theme: {
		name: 'theme',
		persist: [
			{
				storage: sessionStorage,
				pick: ['theme', 'name', 'greetingText'],
			},
		],
	},
	toast: {
		name: 'toast',
	},
	tour: {
		name: 'tour',
		persist: [
			{
				storage: localStorage,
				pick: ['seenByUser'],
			},
		],
	},
	user: {
		name: 'user',
		persist: [
			{
				storage: localStorage,
				pick: ['cookieConsent'],
			},
			{
				storage: sessionStorage,
				pick: ['whoami'],
			},
		],
	},
}

interface StorageConfig {
	storage: Storage
	pick?: string[]
}

interface StoreConfig {
	name: string
	persist?: StorageConfig[]
	storage?: Storage
	persistAll?: boolean
}

export default storeConfigs
